import { render, staticRenderFns } from "./pedido.vue?vue&type=template&id=2a5c4baa"
import script from "./pedido.vue?vue&type=script&lang=js"
export * from "./pedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports